import { Speech, BarChart, Settings } from "lucide-react";
import { useLocation, Link } from "react-router-dom";

export function BottomNavbar() {
  const location = useLocation();
  const currentPath = location.pathname;

  const classCellBgActive = "bg-white";
  const classContentActive = "text-black";

  const isActive = (tab: string) => {
    if (tab === "track" || tab === "settings") {
      return currentPath.startsWith("/" + tab);
    }
    if (tab === "progress") {
      return (
        currentPath.startsWith("/stats") || currentPath.startsWith("/workouts")
      );
    }
    return false;
  };

  return (
    <div className="fixed bottom-6 left-0 right-0 max-w-md mx-auto z-40 px-10">
      <div
        className="rounded-full flex justify-around items-center px-2 py-2"
        style={{
          background: "#09092C", // Dark navy blue color
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        }}
      >
        <Link
          to="/track"
          className={`flex-1 py-2 rounded-full flex flex-col items-center ${
            isActive("track") ? classCellBgActive : ""
          }`}
        >
          <Speech
            className={`h-5 w-5 ${
              isActive("track") ? classContentActive : "text-white"
            }`}
          />
          <span
            className={`text-xs mt-1 font-medium ${
              isActive("track") ? classContentActive : "text-white"
            }`}
          >
            Track
          </span>
        </Link>

        <Link
          to="/stats"
          className={`flex-1 py-2 rounded-full flex flex-col items-center ${
            isActive("progress") ? classCellBgActive : ""
          }`}
        >
          <BarChart
            className={`h-5 w-5 ${
              isActive("progress") ? classContentActive : "text-white"
            }`}
          />
          <span
            className={`text-xs mt-1 font-medium ${
              isActive("progress") ? classContentActive : "text-white"
            }`}
          >
            Progress
          </span>
        </Link>

        <Link
          to="/settings"
          className={`flex-1 py-2 rounded-full flex flex-col items-center ${
            isActive("settings") ? classCellBgActive : ""
          }`}
        >
          <Settings
            className={`h-5 w-5 ${
              isActive("settings") ? classContentActive : "text-white"
            }`}
          />
          <span
            className={`text-xs mt-1 font-medium ${
              isActive("settings") ? classContentActive : "text-white"
            }`}
          >
            Account
          </span>
        </Link>
      </div>
    </div>
  );
}
